import { render, staticRenderFns } from "./MineView.vue?vue&type=template&id=35c36057&scoped=true&"
import script from "./MineView.vue?vue&type=script&lang=js&"
export * from "./MineView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c36057",
  null
  
)

export default component.exports